import { obtenerUsuarioActual } from '@/lib/cliente';
import { Navigate } from 'react-router-dom';

interface Props {
  /** Roles permitidos para esta ruta (ej. ['admin'] o ['admin','supervisor']). */
  roles: string[];
  children: React.ReactNode;
}

/**
 * Restringe una ruta a ciertos roles. Si el usuario no califica, lo redirige a
 * su área por defecto (admin/supervisor → /admin/obras, campo → /campo/avance).
 *
 * Es solo conveniencia de UX: la barrera de seguridad REAL vive en el backend
 * (requiereAdmin/requiereGestion en cada endpoint). En modo dev el usuario es
 * admin, así que el wrapper es transparente.
 */
export function RequiereRol({ roles, children }: Props) {
  const u = obtenerUsuarioActual();
  if (!u || !roles.includes(u.rol)) {
    const destino =
      u && (u.rol === 'admin' || u.rol === 'supervisor') ? '/admin/obras' : '/campo/avance';
    return <Navigate to={destino} replace />;
  }
  return <>{children}</>;
}
